<nb-card class='container'>
  <nb-card-header *ngIf='lookupOnly'>
    {{ lookupTitle }}
  </nb-card-header>
  <nb-card-body>
    <div class="mt-2">
      <ng2-smart-table [settings]="settings"
                       [source]="source"
                       (userRowSelect)="updateSelection($event)"
      >
      </ng2-smart-table>
<!--      <div *ngIf='!data.customer'>-->
<!--        No prospect found !-->
<!--      </div>-->
    </div>
  </nb-card-body>
  <nb-card-footer *ngIf='!lookupOnly'>
    <div>
      <button nbButton status='primary' size='tiny' class='mr-4' (click)='copy()'
              [disabled]='!canCopy || isSubmitting'>Copy ({{ selectedCount }})</button>
      <button nbButton status='primary' size='tiny' (click)='link()'
              [disabled]='!canLink || isSubmitting'>Link ({{ selectedCount }})</button>
    </div>
  </nb-card-footer>
  <nb-card-footer *ngIf='lookupOnly'>
    <button type='button' nbButton status='primary' size='tiny' (click)='close()'>Close</button>
  </nb-card-footer>
</nb-card>
